import { AssetDevice, CurrentState } from './asset';
import { DeviceBrand } from './deviceBrand';
import { DeviceModelCore } from './deviceModel';

export interface DeviceCore {
  _id: string;
  ident: string;
}

export interface MinimalDevice extends DeviceCore {
  sim?: string;
  carrier?: string;
}

export enum GpsType {
  tracking = 1,
  obd,
  camera,
}

export interface Device extends MinimalDevice {
  brand: DeviceBrand;
  model: DeviceModelCore;
  deviceId?: string;
  asset?: AssetDevice;
  imei?: string;
  maxMb?: number;
  gpsType?: GpsType;
  cs?: CurrentState;
  hsWithoutAsset?: StockDeviceState;
  channels?: number;
}

export interface StockDeviceState {
  geoReference?: string | null;
  position_latitude?: number | null;
  position_longitude?: number | null;
  timestamp?: number | null;
  ident?: string | null;
  position_speed?: number | null;
  deviceModel?: string | null;
  notificationType?: number | null;
  engine_ignition_status?: number | null;
  battery_percentage?: number | null;
  external_powersource_voltage?: number | null;
  backup_battery_voltage?: number | null;
}
